import { createStore } from "@crialume/core";
import type { ConfirmOptions, IUiService } from "@crialume/sdk";
import { toast } from "@crialume/ui";
import { useSyncExternalStore } from "react";

interface PendingConfirm {
  options: ConfirmOptions;
  resolve: (confirmed: boolean) => void;
}

const confirmStore = createStore<{ pending: PendingConfirm | null }>({ pending: null });

/** Implementação do IUiService com o design system do shell. */
export const uiService: IUiService = {
  notify(message, kind = "info", description) {
    const options = description ? { description } : undefined;
    if (kind === "info") toast(message, options);
    else toast[kind](message, options);
  },

  confirm(options) {
    // Uma confirmação nova cancela a anterior em aberto.
    confirmStore.getState().pending?.resolve(false);
    return new Promise<boolean>((resolve) => {
      confirmStore.setState({ pending: { options, resolve } });
    });
  },
};

const subscribe = (onChange: () => void) => confirmStore.subscribe(onChange);
const getPending = () => confirmStore.getState().pending;

export function usePendingConfirm() {
  const pending = useSyncExternalStore(subscribe, getPending, getPending);
  const settle = (confirmed: boolean) => {
    pending?.resolve(confirmed);
    confirmStore.setState({ pending: null });
  };
  return { options: pending?.options, open: pending !== null, settle };
}
